module.exports = __webpack_public_path__ + "files/c61db5ec20137c6a4d2914db8d314bca.png";


//////////////////
// WEBPACK FOOTER
// ./images/icons/code.png
// module id = 308
// module chunks = 60